import React, { useContext, useMemo, useState } from 'react'

export interface MenuContextType {
  onClose?: () => void
  selectedSubMenu: React.ReactElement | undefined
  setSelectedSubMenu: (element: React.ReactElement | undefined) => void
}

interface Props {
  children?: React.ReactNode
  onClose?: () => void
}

export const MenuContext = React.createContext<MenuContextType>({
  onClose: () => {},
  selectedSubMenu: undefined,
  setSelectedSubMenu: () => {},
})

export const MenuContextProvider: React.FC<Props> = ({ children, onClose }) => {
  const [selectedSubMenu, setSelectedSubMenu] = useState<
    React.ReactElement | undefined
  >(undefined)

  const contextValue = useMemo(
    () => ({
      selectedSubMenu,
      setSelectedSubMenu,
      onClose,
    }),
    [selectedSubMenu]
  )

  return (
    <MenuContext.Provider value={contextValue}>{children}</MenuContext.Provider>
  )
}

export const useMenuContext = () => useContext(MenuContext)
